import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'antd';

import TableCellAction from '../../../../../components/tablecellaction';

class CannedResponseCard extends React.PureComponent {
    handleEditClick = () => {
        const { canned_response, onCannedMessageEdit } = this.props;
        onCannedMessageEdit(canned_response);
    };

    handleDeleteClick = () => {
        const { canned_response, onCannedMessageDelete } = this.props;
        onCannedMessageDelete(canned_response);
    };

    render() {
        const { canned_response } = this.props;
        return (
            <div className="ori-t-mrgn-10 ori-pad-10 ori-bg-white ori-border-light ori-border-radius-4">
                <div className="ori-relative ori-r-pad-60 ori-l-pad-5 ori-flex-row ori-flex-wrap ori-flex-jsb">
                    <div className="ori-absolute ori-align-right ori-align-top">
                        <TableCellAction align_center show_edit show_delete delete_popconfirm_title="Are you sure delete this canned response?" handleEditClick={this.handleEditClick} handleDeleteClick={this.handleDeleteClick} />
                    </div>
                    <div className="ori-font-md ori-font-bold">#{canned_response.shortcut}</div>
                    <div className="ori-flex-row ori-tb-pad-3">
                        {
                            canned_response.heading && canned_response.heading.length > 0 &&
                            <div className="ori-lr-pad-5">
                                <Tooltip overlayClassName="ori-tooltip-bg-white ori-tooltip-arrow-hidden ori-tooltip-tag" title="Heading">
                                    <div className="ori-lr-pad-6 ori-font-xs ori-border-green ori-bg-green-light ori-font-green ori-border-radius-4">{canned_response.heading}</div>
                                </Tooltip>
                            </div>
                        }
                        {
                            canned_response.subHeading && canned_response.subHeading.length > 0 &&
                            <div className="ori-lr-pad-5">
                                <Tooltip overlayClassName="ori-tooltip-bg-white ori-tooltip-arrow-hidden ori-tooltip-tag" title="Subheading">
                                    <div className="ori-lr-pad-6 ori-font-xs ori-border-danger ori-bg-danger-light ori-font-danger ori-border-radius-4">{canned_response.subHeading}</div>
                                </Tooltip>
                            </div>
                        }
                    </div>
                </div>
                {
                    canned_response.messages && canned_response.messages.length > 0 &&
                    <div className="ori-t-pad-10">
                        {
                            canned_response.messages.map((message, index) => {
                                return (
                                    <div key={index} className="ori-t-border-light ori-pad-10 ori-font-light">{message}</div>
                                );
                            })
                        }
                    </div>
                }
            </div>
        );
    }
}

CannedResponseCard.propTypes = {
    canned_response: PropTypes.object.isRequired,
    onCannedMessageEdit: PropTypes.func,
    onCannedMessageDelete: PropTypes.func,
};

CannedResponseCard.defaultProps = {
    canned_response: {},
};

export default CannedResponseCard;



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/members/cannedresponses/components/cannedresponsecard/index.js